import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Container } from "reactstrap";
import { NDSProvider } from "@nulogy/components";

import Loading from "./components/Loading";
import NavBar from "./components/NavBar";
import Home from "./views/Home";
import { useAuth0 } from "@auth0/auth0-react";
import history from "./utils/history";

// styles
import "./App.css";

// fontawesome
import initFontAwesome from "./utils/initFontAwesome";

initFontAwesome();

const App = () => {
  const { isLoading, error, isAuthenticated, loginWithRedirect } = useAuth0();

  if (error) {
    return <div>Oops... {error.message}</div>;
  }

  if (isLoading) {
    return (
      <NDSProvider>
        <Loading />
      </NDSProvider>
    );
  }
  if (isAuthenticated) {
    return (
      <NDSProvider>
        <BrowserRouter history={history}>
          <div id="app" className="d-flex flex-column h-100">
            <NavBar />
            <Container className="flex-grow-1 mt-5">
              <Routes>
                <Route path="/" exact element={<Home />} />
              </Routes>
            </Container>
          </div>
        </BrowserRouter>
      </NDSProvider>
    );
  } else {
    loginWithRedirect();
  }
};

export default App;
